import React, {useState} from "react";
import { Title } from "../components/AllExportedComponent";
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import { Document, Page, pdfjs } from "react-pdf";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

function MyCV() {
    const [numPages, setNumPages] = useState(null);
    const [pageNumber] = useState(1);

    function onDocumentLoadSuccess({numPages}) {
        setNumPages(numPages);
    }

    return <>
        <div className="w-full px-6 lg:px-8">
            <div className="w-full flex flex-col mt-12 mb-10">
                <Title title="Curriculum" subtitle="Vitae" />
            </div>

            <div className="hidden md:flex flex-col justify-center items-center">
                <Document
                    className="shadow-xl"
                    renderMode="canvas"
                    file={process.env.PUBLIC_URL + '/files/myCV.pdf'}
                    onLoadSuccess={onDocumentLoadSuccess} onLoadError={console.error}
                >
                    {Array.from(
                        new Array(numPages),
                        (el, index) => (
                        <Page
                        className={`my-2`}
                        key={`page_${index + 1}`}
                        pageNumber={index+1}
                    />
                    ),
                    )}
                </Document>
            </div>
            <div className="flex flex-col md:hidden justify-center items-center">
                <Document
                    className="shadow-xl"
                    renderMode="canvas"
                    file={process.env.PUBLIC_URL + '/files/myCV.pdf'}
                    onLoadSuccess={onDocumentLoadSuccess} onLoadError={console.error}
                >
                    <Page
                        height={606}
                        width={300} 
                        pageNumber={pageNumber}
                    />
                </Document>
                <p className="flex my-4 text-sm">Halaman {pageNumber} dari {numPages}</p>
                <p className="flex text-sm text-slate-200 w-64"><small>*Untuk versi mobile cv bisa anda unduh, untuk tampilan yang lebih baik.</small></p>
            </div>
            <div className="flex flex-col justify-center items-center">
                <a className="mt-4 mb-2" href={process.env.PUBLIC_URL + '/files/myCV.pdf'} download="CV_BAGUS_SONARANGGA">
                    <button className="transition ease-in-out py-1 px-3 rounded-md bg-blue-500 hover:-translate-y-1 hover:scale-105 hover:bg-indigo-600 duration-300 ...">UNDUH CV</button>
                </a>
            </div>
        </div>
    </>
}

export default MyCV;